import AboutExtraSection1 from "../sections/AboutExtraSection1"
import AboutSection1 from "../sections/AboutSection1"
import AboutSection2 from "../sections/AboutSection2"
import AboutSection3 from "../sections/AboutSection3"
import AboutSection4 from "../sections/AboutSection4"
import AboutSection5 from "../sections/AboutSection5"
import { AwardsComponent } from "./Home"

const About = () => {
    return (
        <>
            <AwardsComponent />
            <div className="min-h-screen w-full text-center xl:text-left  bg-white dark:bg-transparent relative z-10
    text-black">
                <AboutSection1 />
                <AboutExtraSection1 />
                <AboutSection2 />
                <AboutSection3 />
                <AboutSection4 />
                <AboutSection5 />
            </div>
        </>
    )
}

export default About